
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/calculators/work-hours-calculator",
      function () {
        return require("private-next-pages/calculators/work-hours-calculator/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/calculators/work-hours-calculator"])
      });
    }
  